import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { useSddRepository } from "../../../api/repositories/SddRepository";
import FormTextField from "../../../experiments/forms/FormTextField";
import { STATUS_REVOKED } from "../constants/MandateConstants";

interface Props {
    open: boolean;
    form?: any;
    title: string,
    body: string,
    leftButton: string,
    rightButton: string,
    viewNote?: boolean,
    leftFunction: () => void,
    rigthFunction: () => void,
    onClose: () => void;
}

const MandatesModal = (props: Props) => {
    const { t } = useTranslation("finance", { keyPrefix: "sdd.mandates" });
    const { dispatchGlobalData } = useContext(GlobalContext);
    const { putMandateStatus } = useSddRepository();
    const { handleSubmit, control, register } = useForm<any>({
        defaultValues: {
            notes: ""
        },
    });

    const navigate = useNavigate();
    const onClose = () => {
        props.onClose();
    };

    const onSubmit: SubmitHandler<any> = (data) => {
  
        let mandateStatus = { id: props.form.id, status: props.form.status, notes: data.notes };
        putMandateStatus(mandateStatus).then(() => {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: props.form.status === STATUS_REVOKED ? t('snackbar.success-revoke') : t('snackbar.success-delete'),
                        type: snackbarTypes.success,
                        show: true,
                        autoClose: true
                    }
                }
            });
        }).catch(() => {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: props.form.status === STATUS_REVOKED ? t('snackbar.error-revoke'): t('snackbar.success-delete'),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true
                    }
                }
            });
        });
        navigate(-1);
    }

    return (
        <Mui.Dialog
            open={props.open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: "600px !important",
                    minHeight: "194px",
                    borderRadius: "4px",
                },
            }}
        >
            <Mui.DialogTitle>
                <Mui.Grid
                    container
                    alignItems="center"
                    alignContent="center"
                    direction="row"
                >
                    <Mui.Grid xs item>
                        <Mui.Stack direction="row" alignItems="center" gap={1}>
                            <MuiIcons.Info sx={{ color: '#C8017D' }} fontSize="small" />
                            <Mui.Box >{props.title}</Mui.Box>
                        </Mui.Stack>
                    </Mui.Grid>
                    <Mui.Grid
                        xs
                        item
                        sx={{
                            justifyContent: "flex-end",
                            display: "flex",
                        }}
                    >
                        <MuiIcons.Close
                            color="disabled"
                            fontSize="small"
                            onClick={onClose}
                        />
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>




            <form onSubmit={handleSubmit(onSubmit)}>
                <Mui.Grid>

                    <Mui.DialogContent>
                        <Mui.DialogContentText>
                            {props.body}

                            {props.viewNote &&
                                <Mui.Grid container>
                                    <Mui.Grid item xs="auto" style={{ marginTop: 26 }}>
                                        <Mui.Typography variant="h6">
                                                  {t('modal.notes')}
                                        </Mui.Typography>
                                    </Mui.Grid>
                                    <Mui.Grid item xs={12}>
                                        <FormTextField
                                            name={`notes`}
                                            control={control}
                                            props={{
                                                label: 'Note',
                                                fullWidth: true,
                                            }}
                                        />
                                    </Mui.Grid>
                                </Mui.Grid>
                            }


                        </Mui.DialogContentText>
                    </Mui.DialogContent>
                    <Mui.DialogActions>
                        <Mui.Stack direction="row" spacing={2} p={1} mr={1}>
                            <Mui.Button
                                sx={{
                                    maxWidth: "111px",
                                    maxHeight: "48px",
                                    minWidth: "111px",
                                    minHeight: "48px",
                                }}
                                variant="outlined"
                                onClick={props.leftFunction}
                            >
                                <Mui.Typography
                                    sx={{
                                        textTransform: "capitalize",
                                        fontWeight: 700,
                                        lineHeight: 1.25,
                                        color: "#C8017D",
                                    }}
                                    variant="subtitle1"
                                >
                                    {props.leftButton}
                                </Mui.Typography>
                            </Mui.Button>

                            <Mui.Button
                                sx={{
                                    maxWidth: "181px",
                                    maxHeight: "48px",
                                    minWidth: "111px",
                                    minHeight: "48px",
                                }}
                                type={props.viewNote ? 'submit' : 'button'}
                                variant="contained"
                                color="accent"
                                onClick={props.rigthFunction}
                            >
                                <Mui.Typography
                                    sx={{
                                        textTransform: "capitalize",
                                        fontWeight: 700,
                                        lineHeight: 1.25,
                                        color: 'white'
                                    }}
                                    variant="subtitle1"
                                >
                                    {props.rightButton}
                                </Mui.Typography>
                            </Mui.Button>
                        </Mui.Stack>
                    </Mui.DialogActions>
                </Mui.Grid>
            </form>



        </Mui.Dialog>

    );
}

export default MandatesModal;